export default __webpack_public_path__ + "static/media/PadronFR_No45.bff3f0ad.png";